import { iIconProps } from '../icon';

export default function PlayIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M13.94 6.34c1.63.93 2.92 1.66 3.83 2.32.92.67 1.6 1.38 1.84 2.3.18.68.18 1.39 0 2.07-.24.93-.92 1.63-1.84 2.3-.91.67-2.2 1.4-3.83 2.32-1.58.9-2.91 1.65-3.92 2.08-1.02.43-1.95.65-2.85.4-.66-.19-1.27-.54-1.75-1.03-.66-.67-.92-1.58-1.05-2.69-.12-1.1-.12-2.54-.12-4.37v-.1c0-1.83 0-3.27.12-4.37.13-1.11.39-2.03 1.05-2.69.49-.49 1.09-.85 1.75-1.03.9-.26 1.83-.04 2.85.4 1.01.43 2.34 1.19 3.92 2.08Z'
                fill='currentColor'
            />
        </svg>
    );
}
